import {remCalc} from '../../_utils'
import breakpoints from '../../foundations/breakpoints'

export default {
    baseStyle: {
        container: {
            width: '100%',
            maxWidth: remCalc(1440),
            margin: '0 auto',
            height: 'auto',
            minWidth: 0,
            display: 'flex',
            flexDirection: 'column',
            gap: ['small.base', 'small-1.sm', 'small-1.md', 'small-1.lg'],
            paddingX: ['xsmall.base', 'xsmall.sm', 'medium.md', 'medium.lg'],
            paddingY: ['small-1.base', 'medium.sm', 'medium.md', 'medium.lg'],
        },
        header: {
            flexDirection: 'column',
            gap: ['xxxsmall.base', 'xxxsmall.sm', 'xxxsmall.md', 'xxxsmall.lg'],
        },
        title: {
            textStyle: 'head-large',
            fontWeight: 'light',
            color: 'foreground.neutral.default',
            fontFamily: 'heading',
        },
        subtitle: {
            textStyle: 'head-large',
            fontWeight: 'light',
            color: 'foreground.neutral.subtle',
            fontFamily: 'heading',
        },
        grid: {
            gap: ['xxsmall.base', 'xxsmall.sm', 'xxsmall.md', 'xxsmall.lg'],
            alignItems: 'start',
            minWidth: 0,
        },
        card: {
            display: 'flex',
            flexDirection: 'column',
            minWidth: 0,
            width: '100%',
            marginX: 'auto',
            textDecoration: 'none',
            overflowWrap: 'anywhere',
            _hover: {textDecoration: 'none'},
            _focusVisible: {outline: '2px solid', outlineOffset: remCalc(4)},
        },
        media: {
            position: 'relative',
            width: '100%',
            aspectRatio: '1',
            overflow: 'hidden',
            borderRadius: 'large-1',

            background: 'background.base.deep',
            sx: {'& [data-id="aspect-ratio-dam-image"]': {height: '100%'}},
        },
        image: {
            position: 'absolute',
            inset: 0,
            transform: 'scale(1)',
            transition: 'transform 0.4s ease',
        },
        blurClip: {
            position: 'absolute',
            top: '70%',
            bottom: 0,
            left: 0,
            right: 0,
            zIndex: 1,
            pointerEvents: 'none',
            overflow: 'hidden',
            _after: {
                content: '""',
                position: 'absolute',
                inset: 0,
                zIndex: 2,
                background:
                    'linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.65) 100%)',
            },
            sx: {
                maskImage:
                    'linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.15) 10%, rgba(0, 0, 0, 0.6) 30%, rgba(0, 0, 0, 0.95) 50%, black 60%)',
                WebkitMaskImage:
                    'linear-gradient(180deg, transparent 0%, rgba(0, 0, 0, 0.15) 10%, rgba(0, 0, 0, 0.6) 30%, rgba(0, 0, 0, 0.95) 50%, black 60%)',
            },
        },
        blurImage: {
            position: 'absolute',
            top: 'calc(-100% * 70 / 30)',
            bottom: 0,
            left: 0,
            right: 0,
            filter: `blur(${remCalc(25)})`,
            transform: 'scale(1.01)',
        },
        iconAlignment: {
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: 2,
            pointerEvents: 'none',
            padding: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
        },
        iconContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: remCalc(32),
            height: remCalc(32),
            padding: 0,
            minWidth: remCalc(32),
            flexShrink: 0,
            lineHeight: 1,
            borderRadius: 'large-1',
            background: 'background.base.default',
            color: 'foreground.neutral.default',
            boxShadow:
                '0 0 0 1px var(--border-neutral-highlight, #FFF) inset, 0 1px 2px 0 var(--neutral-xs, rgba(19, 24, 58, 0.08)), 0 0 0 1px var(--neutral-xs, rgba(19, 24, 58, 0.08))',
        },
        icon: {
            display: 'block',
            width: remCalc(16),
            height: remCalc(16),
            flexShrink: 0,
            objectFit: 'contain',
        },
        body: {
            flexDirection: 'column',
            gap: ['xxxsmall.base', 'xxxsmall.sm', 'xxxsmall.md', 'xxxsmall.lg'],
            minWidth: 0,
            color: 'foreground.neutral.default',
        },
        cardTitle: {
            textStyle: 'body-medium',
            fontFamily: 'body',
            fontStyle: 'normal',
            letterSpacing: 0,
            color: 'foreground.neutral.inverse',
            fontWeight: 'medium',
        },
        bodyCopy: {
            textStyle: 'body-small',
            fontFamily: 'body',
            fontStyle: 'normal',
            fontWeight: 'normal',
            letterSpacing: 0,
            color: 'foreground.neutral.dim',
        },
        outsideText: {color: 'foreground.neutral.default'},
        outsideCopy: {color: 'foreground.neutral.muted'},
        outsideBody: {
            paddingY: ['xsmall-1.base', 'xsmall-1.sm', 'xsmall-1.md', 'xsmall-1.lg'],
        },
        insideBody: {
            position: 'relative',
            padding: ['xsmall.base', 'xsmall.sm', 'xsmall.md', 'xsmall.lg'],
            paddingTop: ['medium-2.base', 'medium-2.sm', 'medium-2.md', 'medium-2.lg'],
            color: 'foreground.neutral.inverse',
            flexDirection: 'column',
            gap: ['xxxsmall.base', 'xxxsmall.sm', 'xxxsmall.md', 'xxxsmall.lg'],
            zIndex: 1,
            overflowWrap: 'anywhere',
            marginTop: 0,
            isolation: 'isolate',
            flex: 1,
        },
        textBackdrop: {
            _before: {
                content: '""',
                position: 'absolute',
                inset: 0,
                zIndex: -1,
                backdropFilter: 'blur(10px)',
                WebkitBackdropFilter: 'blur(10px)',
                background: 'linear-gradient(180deg, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.65))',
                pointerEvents: 'none',
            },
        },
        overlay: {
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            alignItems: 'flex-end',
            justifyContent: 'flex-end',
            zIndex: 2,
        },
        cta: {
            width: remCalc(40),
            height: remCalc(40),
            minWidth: remCalc(40),
            margin: remCalc(16),
            flexShrink: 0,
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: 'full',
            background: 'background.base.default',
            color: 'foreground.neutral.default',
            opacity: 1,
            transition: 'opacity 0.3s ease',
        },
        ctaIcon: {boxSize: remCalc(20)},
        interactive: {
            [`@media (min-width: ${breakpoints.breakpoints.lg}) and (hover: hover) and (pointer: fine)`]:
                {
                    '& [data-testid="bentobox-cta"]': {opacity: 0},
                    '&:hover [data-testid="bentobox-image"]': {transform: 'scale(1.05)'},
                    '&:hover [data-testid="bentobox-cta"], &:focus-visible [data-testid="bentobox-cta"]':
                        {
                            opacity: 1,
                        },
                },
            '@media (prefers-reduced-motion: reduce)': {
                '& [data-testid="bentobox-image"], & [data-testid="bentobox-cta"]': {
                    transition: 'none',
                },
                '&:hover [data-testid="bentobox-image"]': {transform: 'none'},
            },
        },
    },
    variants: {
        uniform: {
            grid: {
                templateColumns: {
                    base: 'minmax(0, 1fr)',
                    md: 'repeat(3, minmax(0, 1fr))',
                },
            },
        },
        featured: {
            grid: {
                templateColumns: {
                    base: 'minmax(0, 1fr)',
                    lg: 'repeat(3, minmax(0, 1fr))',
                },
            },
            card: {maxWidth: 'none'},
            dominantCard: {
                gridColumn: {lg: '1 / span 2'},
                gridRow: {lg: '1 / span 2'},
            },
        },
    },
    defaultProps: {variant: 'uniform'},
}
